import React from 'react';

// Mirrors footerHtml() in scripts/layout.js — keep the two in sync.
// DONATE_URL duplicates DONATE_URL in scripts/layout.js — keep the two in sync.
const DONATE_URL = 'https://donate.stripe.com/7sY28rbS80o2dBW9GD3Ru00';
const COLS: [string, [string, string][]][] = [
  [
    'Visorna',
    [
      ['/', 'Alla snapsvisor'],
      ['/?filter=klassiker', 'Kända snapsvisor'],
      ['/helan-gar/', 'Helan går'],
      ['/masen-snapsvisa/', 'Måsen'],
      ['/korta-snapsvisor/', 'Korta snapsvisor'],
      ['/tema/roliga/', 'Roliga snapsvisor'],
      ['/melodi/', 'Melodier'],
    ],
  ],
  [
    'Till festen',
    [
      ['/guide/kraftskiva/', 'Kräftskiva'],
      ['/guide/midsommar/', 'Midsommar'],
      ['/guide/julbord/', 'Julbord'],
      ['/julsnapsvisor/', 'Julsnapsvisor'],
      ['/guide/nyar/', 'Nyårssnapsvisor'],
      ['/guide/snapsregler/', 'Snapsregler'],
      ['/guide/skaltal/', 'Skåltal'],
    ],
  ],
  [
    'Verktyg',
    [
      ['/sanghafte/', 'Skapa eget sånghäfte'],
      ['/skriv-ut/', 'Färdiga häften att skriva ut'],
      ['/sjung-direkt/', 'Sjung direkt'],
      ['/vad-ar-en-snapsvisa/', 'Vad är en snapsvisa?'],
    ],
  ],
];

const SiteFooter: React.FC = () => (
  <footer className="sd-ftr">
    <div className="sd-ftr-in">
      {COLS.map(([heading, links]) => (
        <div key={heading}>
          <h2>{heading}</h2>
          <ul>
            {links.map(([href, label]) => (
              <li key={href}>
                <a href={href}>{label}</a>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <h2>Var med</h2>
        <p>Har ni en visa som saknas? Lägg upp den – den blir gratis för alla att sjunga.</p>
        <a className="sd-ftr-cta" href="/new/">
          Skicka in en snapsvisa
        </a>
        <p className="sd-ftr-support-p">
          Snapsdags är gratis och har inga betalväggar. Vill du stötta sidan?
        </p>
        <a
          className="sd-ftr-support"
          href={DONATE_URL}
          target="_blank"
          rel="nofollow noopener"
          onClick={() => {
            (window as any).gtag?.('event', 'donate_click', { location: 'footer' });
          }}
        >
          Bjud på en nubbe
        </a>
        <ul className="sd-ftr-about">
          <li>
            <a href="/om-oss/">Om oss</a>
          </li>
          <li>
            <a href="/redaktionella-principer/">Redaktionella principer</a>
          </li>
          <li>
            <a href="/kontakt/">Kontakt</a>
          </li>
          <li>
            <a href="/integritetspolicy/">Integritetspolicy</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="sd-ftr-bot">
      <p>
        Snapsdags.com – en fri samling svenska snapsvisor. Alla visor är gratis att läsa, sjunga och
        skriva ut.
      </p>
      <p>
        Texterna kommer från besökare och från allmänt spridd svensk visskatt från 1900-talet och
        framåt. Hittar du ett fel eller vill att något plockas bort? Använd feedbackknappen på sidan.
      </p>
    </div>
  </footer>
);

export default SiteFooter;
